import { Injectable } from '@angular/core';
import { ISupplierViewModel, IVisionSupplierFilterViewModel, VisionUserRegistrationViewModel} from '../../models/accountModel';
import { DataService } from '../data.service';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { SpotLightSupplierViewModel, SpotLightPostModel, DeleteSpotLightDetailsModel, EditSpotLightDetailsModel } from '../../models/rfqModel';
import { VisionSetCustomerSupportRepViewModel } from '../../models/actionTrackerModel';

@Injectable()
export class ManufacurerService {
  moduleUrl: string;
  private retryLimit = 1;

  constructor(private _dataService: DataService, private _httpClient: HttpClient) { }
  getManufacurerList(iVisionSupplierFilterViewModel: IVisionSupplierFilterViewModel): Observable<ISupplierViewModel []> {
    this.moduleUrl = 'Contact/GetVisionSupplier';
    return this._dataService.add(this.moduleUrl, iVisionSupplierFilterViewModel);
  }

  makePremiumSupplier(companyId: number, isPremium: boolean): Observable<any> {
    this.moduleUrl = 'Supplier/MakePremiumSupplier?CompanyId=' + companyId + '&isPremium=' + isPremium;
    return this._dataService.add(this.moduleUrl, '');
  }
  makeSpotLightSupplier(spotLightSupplierViewModel: SpotLightSupplierViewModel): Observable<any> {
    this.moduleUrl = 'Spotlight/SetSpotLightDetails';
    return this._dataService.add(this.moduleUrl, spotLightSupplierViewModel);
  }
  GetSpotLightManufacturers(iVisionSupplierFilterViewModel: SpotLightPostModel): Observable<SpotLightSupplierViewModel []> {
    this.moduleUrl = 'Spotlight/GetSpotLightManufacturers';
    return this._dataService.add(this.moduleUrl, iVisionSupplierFilterViewModel);
  }
  setSupplierAccountType(companyId: number, AccountType: string, loggedInContactId: number): Observable<any> {
    this.moduleUrl = 'Supplier/SetSupplierAccountType?CompanyId=' + companyId + '&AccountType=' + AccountType +'&LoggedInContactId='+loggedInContactId;
    return this._dataService.add(this.moduleUrl, '');
  }
  SetSupplierMQS(companyId: number, is_MQS_On: boolean): Observable<any> {
    this.moduleUrl = 'QMS/SetSupplierMQS?CompanyId=' + companyId + '&is_MQS_On=' + is_MQS_On;
    return this._dataService.add(this.moduleUrl, '');
  }
  SetVerifyEmail(userId: string): Observable<any> {
    this.moduleUrl = 'AccountEmailVerification/VerifyEmail?userId=' + userId;
    return this._dataService.UpdateWithoutId(this.moduleUrl, '');
  }

  getSubscriptionCapabilitiesToAdd(): Observable <any> {
    this.moduleUrl = 'Master/GetSubscriptionCapabilitiesToAdd';
    return this._dataService.getAll(this.moduleUrl, '');
  }

  setCustomerSupportRep(visionSetCustomerSupportRepViewModel:VisionSetCustomerSupportRepViewModel): Observable < any > {
    this.moduleUrl = 'SetCustomerSupportRep';
    return this._dataService.updatePass(this.moduleUrl, visionSetCustomerSupportRepViewModel);
  }
  setVisionUserRegistrationViewModel(ivisionUserRegistrationViewModel: VisionUserRegistrationViewModel): Observable<any> {
    this.moduleUrl = 'VisionUserRegistration';
    return this._dataService.add(this.moduleUrl, ivisionUserRegistrationViewModel);
  }

  search(term:string): Observable < any > {
    this.moduleUrl = 'Contact/GetAddressLookUpData?Address=' +term;
    return this._dataService.add(this.moduleUrl,'');
  }

  getSpotlightRankList(partId: number, manufacLocID:number): Observable <any> {
    this.moduleUrl = 'SpotLight/GetSpotlightRankList?partCategoryId=' + partId + '&manufacturingLocationId='+ manufacLocID;
    return this._dataService.getAll(this.moduleUrl, '');
  }

  changeManufacturerRankPosition(ranklist:any): Observable < any > {
    this.moduleUrl = '/SpotLight/ChangeManufacturerRankPosition';
    return this._dataService.add(this.moduleUrl, ranklist);
  }

  editSpotLightDetails(editPost: EditSpotLightDetailsModel): Observable < any > {
    this.moduleUrl = '/SpotLight/EditSpotLightDetails';
    return this._dataService.add(this.moduleUrl, editPost);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/Manufacturer/manufacurer.service.ts